import { Enums } from '../tasks/interfaces'

interface EnumType {
  label: string | number
  value?: string | number
  disabled?: boolean
}

interface FilterOptions {
  enum?: EnumType[]
  width?: string
  tooltip?: string
  allowClear?: boolean
  mode?: 'multiple' | 'tags'
  min?: number
  max?: number
}

interface filtersType {
  type:
    | 'input-string'
    | 'input-integer'
    | 'select'
    | 'phone'
    | 'dates'
    | 'filter_group'
    | 'select_multiple'
    | 'range'
  items?: filtersType[]
  name: string
  label?: string
  options?: FilterOptions
  style?: React.CSSProperties
  placeholder?: string | string[]
  prefix?: string
  disabled?: boolean
  value?: string | number | readonly string[] | string[]
  skipReset?: boolean
}

export const getFilters = (filters: any, enums: Enums): filtersType[] => {
  return [
    {
      name: 'id',
      placeholder: 'Найти задачу',
      prefix: 'ID',
      type: 'input-integer',
      value: filters?.id || undefined,
      options: {
        width: '170px',
        tooltip: 'ID',
      },
    },
    {
      name: 'responsible',
      placeholder: 'Ответственный',
      type: 'select',
      value: filters?.responsible && !isNaN(filters.responsible) ? filters.responsible : undefined,
      options: {
        width: '170px',
        enum: enums?.responsible || [],
        tooltip: 'Ответственный',
      },
    },
    {
      name: 'task_type',
      placeholder: 'Тип задачи',
      type: 'select_multiple',
      value: filters?.task_type?.split
        ? filters.task_type.split(',').filter(Boolean)
        : filters?.task_type,
      options: {
        width: '170px',
        enum:
          enums?.task_type?.map(item => ({
            ...item,
            value: String(item.value),
          })) || [],
        tooltip: 'Тип задачи',
      },
    },
    {
      name: 'dates',
      placeholder: ['Начальная', 'Конечная'],
      type: 'dates',
      value: filters?.dates || undefined,
      options: {
        width: '220px',
        tooltip: 'Плановая дата',
      },
    },
  ]
}
